export default "__VITE_ASSET__BUUkpZIM__"